/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m15 11.1982526c0-.1-.021-.198-.059-.288-.038-.092-.092-.174-.162-.243l-.001-.001-3.571-3.55100004c-.292-.292-.769-.291-1.061.003s-.29.769.004 1.061l2.283 2.26900004h-10.683c-.414 0-.75.336-.75.75s.336.75.75.75h10.682l-2.283 2.27c-.293.293-.295.767-.003 1.061.148.147.34.221.533.221.191 0 .383-.073.529-.218l3.571-3.552c.017-.016.024-.04.039-.058.048-.057.094-.115.123-.184.038-.092.059-.189.059-.29m-14-6.39700004c0-.101.021-.199.059-.29.038-.09.093-.172.162-.241v-.001l3.571-3.551c.294-.292.769-.291 1.061.003.292.293.291.769-.003 1.06l-2.282 2.27h10.682c.414 0 .75.336.75.75s-.336.75-.75.75h-10.682l2.282 2.27c.294.292.295.767.003 1.06-.146.147-.339.221-.532.221-.191 0-.382-.072-.529-.218l-3.571-3.551v-.001c-.069-.069-.124-.151-.162-.241-.038-.091-.059-.189-.059-.29" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;